import { ref } from "vue";
import { a as breadcrumbGlobalIndexKey, e as breadcrumbPluginKey } from "../../../keys-DUCx0SNv.mjs";
const breadcrumbPlugin = {
  install(app) {
    const items = ref({
      [breadcrumbGlobalIndexKey]: []
    });
    const reset = (key = breadcrumbGlobalIndexKey) => {
      items.value[key] = [];
    };
    app.provide(breadcrumbPluginKey, { items, reset });
  }
};
export {
  breadcrumbPlugin
};
//# sourceMappingURL=index.mjs.map
